export default "__VITE_ASSET__DTS7oGbn__"